import styled from 'styled-components';
export const DialogContent = styled.div `
  display: grid;
  margin: 0 0.5em;
  label {
    font-size: 100%;
  }
  div {
    margin: 0.5em 0;
  }
`;
export const Spacer = styled.div `
  Button:first-child {
    margin-right: 8px;
  }
`;
